<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="max-width-25per pr-0">
              <v-spacer></v-spacer>
              Assets:
            </v-card-title>
            <v-card-text class="vh-80">
              <v-data-table
                dense
                hide-default-header
                :headers="headers"
                :items="adminAssetsSettingsItems"
                class="max-width-50vw border-thin mx-25per mt-8"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:[`item.Name`]="{ item }">
                    <span class="subtitle-1"> {{ item.Name }} </span>
                    <span v-if="item.new" class="ml-2 green--text new">New</span>
                </template>
                <template v-slot:[`item.Actions`]="{ item }">
                  <v-btn color="primary" outlined small @click="manageClick(item)">Manage</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <AssetCategoriesManager
      v-model="assetCategoriesDialog"
    />
    <AssetsStatusesManager
      v-model="showAssetsStatusesDialog"
      :assets_statuses="assets_statuses"
    />
  </div>
</template>
<script>
export default {
  name: 'AdminAssets',
  components: {
    AssetCategoriesManager: () => import('@/components/assets/AssetCategoriesManager.vue'),
    AssetsStatusesManager: () => import('@/components/assets/AssetsStatusesManager.vue')
  },
  data () {
    return {
      rolesOfCurrentUser: [],
      headers: [
        {
          text: 'Name',
          value: 'Name',
          class: 'px-2 text-no-wrap',
          width: '90%'
        },
        {
          text: '',
          value: 'Actions',
          class: 'px-2 text-no-wrap',
          width: '10%',
          align: 'right'
        }
      ],
      adminAssetsSettingsItems: [
        { Name: 'Asset Categories', new: true },
        { Name: 'Asset Statuses' }
      ],
      assetCategoriesDialog: false,
      assets_statuses: [],
      showAssetsStatusesDialog: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    HRorFinancierRole () {
      let res = false
      for (let i = 0; i < this.rolesOfCurrentUser.length; i++) {
        if (this.rolesOfCurrentUser[i].RoleName === 'HR' || this.rolesOfCurrentUser[i].RoleName === 'financier') {
          res = true
          break
        }
      }
      return res
    }
  },
  mounted () {
    if (!this.rolesOfCurrentUser.length) {
      this.getRolesOfCurrentUser()
    }
  },
  methods: {
    getRolesOfCurrentUser () {
      this.axios.get('/api/employee_role/' + this.user.login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.rolesOfCurrentUser = result.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getAssetsStatuses () {
      this.axios.get('/api/assets_status', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        if (response) {
          this.assets_statuses = []
          for (let i = 0; i < response.data.length; i++) {
            this.assets_statuses.push(response.data[i])
          }
        }
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    openAssetsStatusesManager () {
      this.getAssetsStatuses()
      this.showAssetsStatusesDialog = true
    },
    manageClick (item) {
      switch (item.Name) {
        case 'Asset Categories' :
          this.assetCategoriesDialog = true
          break
        case 'Asset Statuses' :
          this.openAssetsStatusesManager()
          break
      }
    }
  }
}
</script>
<style lang="scss">
  .max-width-50vw {
    max-width: 50vw;
  }
  .border-thin {
    border: thin solid #9e9e9e
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) {
    border-bottom: thin solid #9e9e9e
  }
  .mx-25per {
    margin-left: 25%;
    margin-right: 25%;
  }
  .vh-80 {
    height: 80vh;
  }
  tr {
    height: 40px !important;
  }
  .max-width-25per {
    max-width: 25%;
  }
  .new, .deprecated {
    font-size: 9px;
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
    display: inline-block;
    transform: translate(0, -5px);
  }
</style>
